var TableGeneralDataToGoModelUtil = /** @class */ (function () {
    function TableGeneralDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    TableGeneralDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    TableGeneralDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        this.saveComponentProperty('stroke', data.stroke);
        this.saveComponentProperty('splitLine', data.splitLine);
        this.saveComponentProperty('fill', data.fill);
        this.saveComponentProperty('isHiddenColumnSplitLine', data.isHiddenColumnSplitLine);
        this.saveComponentProperty('isHiddenRowSplitLine', data.isHiddenRowSplitLine);
    };
    return TableGeneralDataToGoModelUtil;
}());
export { TableGeneralDataToGoModelUtil };
